export const HttpHeaders = {
    // Заголовок для передачи id запроса, который генерирует клиент
    REQUEST_ID: 'rquid', // нижний регистр важен, т.к. в запросе они приходят в нижнем регистре
    LOCATION: 'Location',
    RETRY_AFTER: 'Retry-After',
    X_SFA_ORGCTX: 'x-sfa-orgctx'
};
